import { Avatar } from 'antd'
import React, { useContext, useState, useMemo } from 'react'
import { defaultUserImg } from '../../helper/imagepath'
import TableView from '../../component/common/tableView'
import { itemRender } from '../../helper/paginationfunction'
import UpdatePaymentStatus from './updatePaymentStatus'
import CustomModal from '../../component/customModal'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { errorToast, successToast } from '../../util/Toast/toast'
import { format } from 'date-fns'
import { getAuthToken } from '../../helper/storage'
import { appendImageURL, checkIfPastDate, getBookingDayjs, getDayStartAndEndTimestamps, getTimeStamp } from '../../helper/function'
import { SpinnerContext } from '../../context/spinnerContext'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import CancelModalContent from '../../component/scheduleStatus/canceleModalContent'
import StatusModal from '../../component/modal/statusModal'
import { getSchedulePropertyDataById } from '../../redux/slices/propertySlice'
import dayjs from 'dayjs'

const Exits = ({ pageExits, pageSizeExits, handleExitsPaginationChange, filterData }) => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { allExitsData } = useSelector(({ payment }) => payment)

  // const [selectedOption, setSelectedOption] = useState(null)
  // const [selectedRows, setSelectedRows] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [isRefresh, setIsRefresh] = useState(false)
  const { scheduledProperties } = useSelector(({ property }) => property)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [chatUserId, setChatUserId] = useState(null)
  const [modalName, setModalName] = useState(null)
  const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false)
  const toggleUpdateStatusModal = () => setShowUpdateStatusModal(!showUpdateStatusModal)

  // const statusOptions = [
  //   { label: 'All', value: 'all' },
  //   { label: 'Pending', value: 'pending' },
  //   { label: 'Paid', value: 'paid' },
  //   { label: 'Penalty', value: 'penalty' },
  //   { label: 'Partially', value: 'partially' }
  // ]

  // const handleChange = (selectedOption) => {
  //   setSelectedOption(selectedOption)
  //   console.log('Selected:', selectedOption)
  //   setSelectedRows([selectedOption?.value]) // Reset selected rows when status changes
  // }

  const handleInvoiceExport = async () => {
    try {
      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(filterData?.created_end))
      // Construct the params object
      const params = {
        ...(filterData?.hostname && { host_name: filterData.hostname }),
        ...(filterData?.cleaner && { cleaner_name: filterData.cleaner }),
        ...(filterData?.region && { region_id: filterData.region }),
        ...(filterData?.created_start && { startTimestamps: filterData?.created_start && getTimeStamp(filterData?.created_start) }),
        ...(filterData?.created_end && { endTimestamps: filterData?.created_end && endOfDayTimestamp }),
        sort_column: 'booking_date_time',
        sort_order: 'DESC',
        timezone: dayjs.tz.guess()
      }

      changeLoader(true)
      // Make the API call
      // eslint-disable-next-line no-undef
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/cleaner-log/export-cleaner-logs-admin`, {
        params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getAuthToken()}` // Passing the token in the header
        }
      })

      // Check for successful response
      if (response.status === 200) {
        // Format the current date and time as 'DD MMM YYYY hh:mm A'
        const currentDateTime = format(new Date(), 'dd MMM yyyy hh:mm a')
        // Create a Blob URL for downloading the file
        const url = window.URL.createObjectURL(new Blob([response?.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Invoice-${currentDateTime}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
        successToast(response?.data?.status_message || 'File downloaded successfully.')
      } else {
        throw new Error(response?.data?.status_message || 'An error occurred while exporting the invoice.')
      }
    } catch (err) {
      // Handle errors from the backend or network issues
      if (err.response && err.response.data) {
        errorToast(err.response.data.message || 'No invoices found.')
      } else {
        errorToast(err.message || 'Something went wrong. Please try again.')
      }
      console.error('>>Err:', err)
    } finally {
      changeLoader(false)
    }
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'schedule_number',
      key: 'propertySchedule',
      render: (text, record) => `#${record?.propertySchedule?.schedule_number}`
    },
    {
      title: 'Host',
      dataIndex: 'host',
      key: 'host',
      render: (text, record) => (
        <div className="table-avatar d-flex align-items-center">
          <Avatar
            src={record?.propertySchedule?.properties?.client?.profile_image || defaultUserImg}
            alt={record?.propertySchedule?.properties?.client?.first_name}
          />
          <span style={{ marginLeft: 10 }}>
            {record?.propertySchedule?.properties?.client?.first_name} {record?.propertySchedule?.properties?.client?.last_name}
          </span>
        </div>
      )
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region',
      render: (text, record) => <p>{record?.propertySchedule?.properties?.region ? record?.propertySchedule?.properties?.region?.region : '-'}</p>
    },
    {
      title: 'Cleaner',
      dataIndex: 'cleaner',
      key: 'cleaner',
      render: (text, record) => (
        <div className="table-avatar d-flex align-items-center">
          <Avatar
            src={record?.cleaners?.profile_image ? appendImageURL(record?.cleaners?.profile_image) : defaultUserImg}
            alt={record?.cleaner_name}
          />
          <span style={{ marginLeft: 10 }}>
            {record?.cleaners?.first_name} {record?.cleaners?.last_name}
          </span>
        </div>
      )
    },
    {
      title: 'Booking',
      dataIndex: 'propertySchedule',
      render: (text) => <p>{getBookingDayjs(text, text?.properties?.timezone)?.format('DD MMM YYYY')}</p>
    },
    {
      title: 'Cleaning',
      dataIndex: 'cleaning',
      key: 'cleaning',
      render: (text, record) => <p>{record?.propertySchedule?.ilink_label ? record?.propertySchedule?.ilink_label : '-'}</p>
    },
    // {
    //   title: 'Payment Status',
    //   dataIndex: 'status',
    //   key: 'status'
    // },
    {
      title: 'Payment',
      dataIndex: 'final_amount',
      key: 'final_amount',
      render: (text) => `${text} USD`
    }
  ]

  // Control row selection based on selected status
  // const rowSelection = {
  //   // selectedRowKeys: selectedRows,
  //   onChange: (selectedRowKeys) => {
  //     setSelectedRows(selectedRowKeys)
  //   },
  //   getCheckboxProps: (record) => ({
  //     disabled: selectedOption?.value !== 'all' && record.payment_status !== selectedOption?.value // Only enable rows that match selected status
  //   })
  // }
  const handleTableClick = (record) => {
    handlePropertyData(record?.propertySchedule, record?.propertySchedule?.booking_status)
  }

  const handlePropertyData = (property_schedule, booking_status) => {
    if (['scheduled', 'canceled', 'in progress', 'canceled cleaner'].includes(booking_status)) {
      setChatUserId(property_schedule.property_schedule_id)
      getPropertyData(property_schedule.property_schedule_id, booking_status)
    } else if (booking_status === 'completed') {
      navigate(`/calendar/complete-cleaning/${property_schedule.property_schedule_id}/cleaningDetail`)
    }
  }

  const getPropertyData = async (schedule_id, booking_status) => {
    changeLoader(true)
    try {
      dispatch(getSchedulePropertyDataById(schedule_id)).then(() => {
        setModalName(booking_status)
        setIsStatusModalOpen(true)
      })
      changeLoader(false)
    } catch (err) {
      console.error('Error fetching property data:', err)
    } finally {
      changeLoader(false)
    }
  }

  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData?.properties]
  )

  const overFun = useMemo(() => {
    return scheduledProperties?.getPropertyScheduleData?.next_checkin_time
      ? checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.next_checkin_time, false)
      : checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.booking_date_time, true)
  }, [scheduledProperties?.getPropertyScheduleData])

  return (
    <>
      {/* <div className="d-flex justify-content-between mb-4 align-items-center column-gap-3 row-gap-3 flex-wrap">
        <div className="form-group input_text border-remove dark_border_divs mb-0">
          <Select
            className="react-selectcomponent form-control select-box-filed"
            options={statusOptions}
            isClearable
            isSearchable
            placeholder="Select Status"
            classNamePrefix="select_kanakku"
            value={selectedOption}
            onChange={handleChange}
          />
        </div>
        <div>
          <Button
            className="btn btn-primary"
            onClick={toggleUpdateStatusModal}
            disabled={!selectedRows.length} // Disable button if no rows are selected
          >
            {`Update Selected Payment’s Status`}
          </Button>
        </div>
      </div> */}
      <div className="common_heading_div">
        <h4>&nbsp;</h4>
        <Button
          className="btn btn-primary d-flex align-items-center gap-1 white_icon_with_btn"
          type="button"
          onClick={() => {
            handleInvoiceExport()
          }}
        >
          Export
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.375 6.875V11.375C14.3571 11.8552 14.1498 12.3089 13.7985 12.6368C13.4472 12.9647 12.9803 13.1402 12.5 13.125H2.5C2.01967 13.1402 1.55284 12.9647 1.20152 12.6368C0.850193 12.3089 0.642926 11.8552 0.625 11.375V6.875C0.625 6.70924 0.690848 6.55027 0.808058 6.43306C0.925268 6.31585 1.08424 6.25 1.25 6.25C1.41576 6.25 1.57473 6.31585 1.69194 6.43306C1.80915 6.55027 1.875 6.70924 1.875 6.875V11.375C1.89528 11.5225 1.97143 11.6567 2.08773 11.7497C2.20403 11.8428 2.3516 11.8876 2.5 11.875H12.5C12.6484 11.8876 12.796 11.8428 12.9123 11.7497C13.0286 11.6567 13.1047 11.5225 13.125 11.375V6.875C13.125 6.70924 13.1908 6.55027 13.3081 6.43306C13.4253 6.31585 13.5842 6.25 13.75 6.25C13.9158 6.25 14.0747 6.31585 14.1919 6.43306C14.3092 6.55027 14.375 6.70924 14.375 6.875ZM5.99375 4.89375L6.875 4.00625V9.375C6.875 9.54076 6.94085 9.69973 7.05806 9.81694C7.17527 9.93415 7.33424 10 7.5 10C7.66576 10 7.82473 9.93415 7.94194 9.81694C8.05915 9.69973 8.125 9.54076 8.125 9.375V4.00625L9.00625 4.89375C9.06435 4.95233 9.13348 4.99883 9.20964 5.03056C9.2858 5.06229 9.36749 5.07862 9.45 5.07862C9.53251 5.07862 9.6142 5.06229 9.69036 5.03056C9.76652 4.99883 9.83565 4.95233 9.89375 4.89375C9.95168 4.83535 9.9975 4.76609 10.0286 4.68994C10.0597 4.61379 10.0755 4.53225 10.075 4.45C10.0755 4.36775 10.0597 4.28621 10.0286 4.21006C9.9975 4.13391 9.95168 4.06465 9.89375 4.00625L7.94375 2.05625C7.83673 1.94944 7.69462 1.88504 7.54375 1.875H7.425C7.29996 1.88986 7.18232 1.94214 7.0875 2.025H7.05625L5.10625 4.00625C4.98856 4.12394 4.92244 4.28356 4.92244 4.45C4.92244 4.61644 4.98856 4.77606 5.10625 4.89375C5.22394 5.01144 5.38356 5.07756 5.55 5.07756C5.71644 5.07756 5.87606 5.01144 5.99375 4.89375Z"
              fill="white"
            />
          </svg>
        </Button>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    // rowSelection={rowSelection}
                    columns={columns}
                    scroll={allExitsData?.data?.length > 0 ? { x: true } : false}
                    dataSource={allExitsData?.data} // Don't filter the data, keep all rows visible
                    onRow={(record) => {
                      return {
                        onClick: () => handleTableClick(record)
                      }
                    }}
                    paginationConfig={{
                      total: allExitsData?.totalRecords || 0,
                      defaultPageSize: allExitsData?.limit || 10,
                      defaultCurrent: allExitsData?.currentpage || 1,
                      current: pageExits,
                      pageSize: pageSizeExits,
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                      onChange: handleExitsPaginationChange,
                      itemRender: itemRender
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showUpdateStatusModal && (
        <CustomModal isOpen={showUpdateStatusModal} toggle={toggleUpdateStatusModal} title={`Update the status of selected payments`} size={'lg'}>
          <UpdatePaymentStatus toggle={toggleUpdateStatusModal} setIsRefresh={setIsRefresh} />
        </CustomModal>
      )}

      {/* Modal open */}
      {isStatusModalOpen && (
        <StatusModal
          onClose={() => setIsStatusModalOpen(false)}
          title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
          headerContent={{
            name: clientName,
            status: scheduledProperties?.getPropertyScheduleData?.booking_status
          }}
          chatUserId={chatUserId}
          CheckTimeOver={overFun}
          clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
        >
          {['canceled', 'in progress', 'canceled cleaner']?.includes(modalName) && (
            <CancelModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              finalAmount={scheduledProperties?.finalAmount}
              onClose={() => setIsStatusModalOpen(false)}
            />
          )}
        </StatusModal>
      )}
    </>
  )
}

export default Exits
